import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import {
  getMediaAttributes,
  getResizableAttributes,
  isHTMLElementNode,
} from '../helpers/serializerHelpers';
import { type ImageElement } from '../../types/aha-editor';
import { isImageElement } from '../../types/guards';

class SerializerImage extends Serializer {
  static deserialize({ el }: DeserializeArguments): ImageElement | undefined {
    if (!isHTMLElementNode(el) || el.tagName.toLowerCase() !== 'img') return;

    const mediaData = getMediaAttributes(el);

    const alt = el.getAttribute('alt');
    if (alt) {
      mediaData.media_alt = alt;
    }

    return {
      type: 'image',
      children: [{ text: '' }],
      ...getResizableAttributes(el),
      ...mediaData,
    };
  }

  static serialize({ node }: SerializeArguments): React.ReactNode {
    if (!isImageElement(node)) return;

    const {
      resizer_width,
      resizer_height,
      resizer_originalWidth,
      resizer_originalHeight,
      media_src, // TODO: this needs to be made absolute.
      media_position,
      media_alt,
    } = node;

    return (
      <img
        width={resizer_width}
        height={resizer_height}
        data-original-width={resizer_originalWidth}
        data-original-height={resizer_originalHeight}
        data-position={media_position}
        src={media_src}
        alt={media_alt}
      />
    );
  }
}

export default SerializerImage;
